"use strict";

// gotta keep it within MAX_SAFE_INTEGER
var extraDigits = 3;

module.exports = createRandomId;

function createRandomId() {
  // 13 time digits
  var datePart = new Date().getTime() * Math.pow(10, extraDigits);
  // 3 random digits
  var extraPart = Math.floor(Math.random() * Math.pow(10, extraDigits));
  // 16 digits
  return datePart + extraPart;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ledgerhq/web3-subprovider/node_modules/web3-provider-engine/dist/es5/util/random-id.js
// module id = 1247
// module chunks = 0